import type { ReactNode } from 'react'

interface SectionProps {
  children: ReactNode
  id?: string
  className?: string
  fullWidth?: boolean
}

export default function Section({ children, id, className, fullWidth }: SectionProps) {
  const baseClasses = fullWidth ? 'w-full' : 'w-full max-w-container mx-auto px-6 sm:px-8'

  return (
    <section id={id} className={`${baseClasses}${className ? ` ${className}` : ''}`}>
      {children}
    </section>
  )
}
